import { Box } from '@nerdwallet/currency/components/Box';
import CloseIcon from '@nerdwallet/react-icon/material/Close';

interface CloseIconProps {
  isMobile?: boolean;
  onClick: () => void;
}

const BannerCloseIcon: React.FC<CloseIconProps> = ({
  isMobile = false,
  onClick,
}) => (
  <Box
    display={{
      desktop: isMobile ? 'none' : 'flex',
      mobile: isMobile ? 'flex' : 'none',
    }}
  >
    <CloseIcon size={24} onClick={onClick} />
  </Box>
);

export default BannerCloseIcon;
